import axios from 'axios';

const validateCep = (zipCode) =>
  axios.get(`https://viacep.com.br/ws/${zipCode}/json`);

export default validateCep;
